var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"resize",rawName:"v-resize:debounce.100",value:(_vm.onResize),expression:"onResize",arg:"debounce",modifiers:{"100":true}}],staticClass:"plotlygraph",style:({
    height: (_vm.height) +  '%',
    width: (_vm.width) + '%'
  }),attrs:{"id":_vm.id}})
}
var staticRenderFns = []

export { render, staticRenderFns }